import { Observable, catchError, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';
import { VesselParticulars } from '@navstation-portal/vessels/data-model/vessel';

interface GetVesselParticularsResponse {
  data: VesselParticulars;
}

@Injectable({ providedIn: 'root' })
export class VesselParticularsService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('VesselParticulars');

  getVesselParticulars(vesselId: string): Observable<VesselParticulars> {
    return this.http.get<GetVesselParticularsResponse>(`${this.baseUrl}/analytics/${vesselId}/vesselParticulars`).pipe(
      map((response) => response.data),
      catchError(this.apiError.toApiError('getting vessel particulars'))
    );
  }
}
